import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  CampaignStatusType, GetCampaignByIdNoTagsGQL, GetCampaignEntityTypeConfigurationsGQL
} from 'generated/graphql';


/**
 * Ensures that a campaign is set.
 * If param is not set returns user to start page to select campaign.
 */
export function mustHaveCampaignFunctionalGuard(): CanActivateFn {
  return (route, _state) => {
    const getCampaignGQL = inject(GetCampaignByIdNoTagsGQL);
    const getCampaignEntityConfigsGQL = inject(GetCampaignEntityTypeConfigurationsGQL);
    const router = inject(Router);

    const queryParams = route.queryParams;

    if (!queryParams.campaignId) {
      return of(router.parseUrl('/select-campaign'));
    }

    // Warm up the cache
    getCampaignEntityConfigsGQL.fetch({ campaignId: queryParams.campaignId }).subscribe();

    return getCampaignGQL.fetch({ campaignId: queryParams.campaignId }).pipe(
      map(({ data }) => data.getCampaign.status === CampaignStatusType.Active),
      map((active) => {
        if (!active) {
          return router.parseUrl('/select-campaign');
        }
        return true;
      })
    );
  }
}
